import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, PlayCircle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

const Card = ({ m }) => (
  <div data-testid={`public-module-${m.order}`} className="lux-card flex min-w-0 flex-col overflow-hidden">
    {m.videos[0]?.thumbnail ? (
      <div className="relative aspect-video bg-black">
        <img src={m.videos[0].thumbnail} alt={m.title} loading="lazy" className="h-full w-full object-cover opacity-80" />
        <PlayCircle className="absolute left-1/2 top-1/2 h-12 w-12 -translate-x-1/2 -translate-y-1/2 text-amber-300/90" />
      </div>
    ) : (
      <div className="flex aspect-video items-center justify-center bg-gradient-to-br from-[#1a1712] to-[#0a0a0c]"><BookOpen className="h-12 w-12 text-amber-400" /></div>
    )}
    <div className="space-y-2 p-5">
      <p className="lux-eyebrow">Module {m.order}</p>
      <h2 className="text-lg text-amber-50">{m.title}</h2>
      <p className="text-sm text-zinc-400">{m.description}</p>
      <p className="text-xs text-zinc-600">{m.kind === "text" ? "Reading" : `${m.videos.length} video${m.videos.length === 1 ? "" : "s"}`} · {m.question_count} quiz questions</p>
    </div>
  </div>
);

export default function DriverTrainingPublic() {
  const [mods, setMods] = useState([]);
  useEffect(() => { api.get("/training/public").then(({ data }) => setMods(data)); }, []);
  return (
    <div className="min-h-screen bg-[#0a0a0c]">
      <header className="mx-auto flex h-20 max-w-7xl items-center justify-between px-5 sm:h-24 sm:px-10"><Logo /><Link to="/login" className="text-sm text-amber-200">Sign in</Link></header>
      <main className="mx-auto max-w-7xl px-5 pb-20 pt-6 sm:px-10" data-testid="driver-training-public">
        <p className="lux-eyebrow">Drive with Us</p>
        <h1 className="mt-3 text-4xl font-semibold text-amber-50 sm:text-5xl lg:text-6xl">Driver Training</h1>
        <p className="mt-5 max-w-2xl text-zinc-400">Every Luxury Rideshare chauffeur completes these modules and passes a final test (80%) before their first ride.</p>
        <Link to="/login" data-testid="training-public-cta" className="btn-gold mt-8">Sign in as a driver to take the training and test</Link>
        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">{mods.map((m) => <Card key={m.id} m={m} />)}</div>
        <p className="mt-10 text-xs text-zinc-600">Videos are third-party content embedded from YouTube and belong to their creators.</p>
      </main>
    </div>
  );
}
